import { Component,OnInit, ViewChildren, ElementRef, Output, EventEmitter } from '@angular/core';
import { UserService } from '../user.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {

  public email: any;
  click: boolean = false;
  otpDisable:boolean=true;
  changePwd: boolean = false;
  public cnfPswd: any;
  public newPswd: any;

  t = {leftTime: 60};

  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
@ViewChildren('formRow') rows: any;
@Output() resend: EventEmitter<any> = new EventEmitter();

  form: FormGroup;
  submit_enable: any;
  enabling_datas: any;
  resend_enable: boolean;
  constructor(public usr: UserService,
    public router: Router,
    public toastr: ToastrService
  ) { 
    this.form = this.toFormGroup(this.formInput);
    // console.log(this.form.value);
    
  }

  toFormGroup(elements) {
    const group: any = {};
    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
   }
   
   keyUpEvent(event, index) {
    let pos = index;
    if (event.keyCode === 8 && event.which === 8) {
     pos = index - 1 ;
    } else {
     pos = index + 1 ;
    }
    if (pos > -1 && pos < this.formInput.length ) {
     this.rows._results[pos].nativeElement.focus();
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      this.submit_enable=true;
      // console.log(this.submit_enable);
    }, 60000);
  }

  submitForgot(){
    this.resend.emit('resend');
    this.t = {leftTime: 60};
    this.submit_enable = false;
    this.ngOnInit();
    // console.log("Otp Clicked");
  }
 
  otp(){
    let obj = {
      "otp": this.form.value.input1+
      this.form.value.input2+
      this.form.value.input3+
      this.form.value.input4+
      this.form.value.input5+
      this.form.value.input6
    }
    // console.log(obj);
    this.usr.otpExpired(obj).subscribe((res:any)=>
    {
      if(res.code===200)
      {
        this.enabling_datas=res;
        this.toastr.success("Otp Verified");
        this.otpDisable=!this.otpDisable;
      }
      else{
        this.toastr.error("Not verified");
      }
    },(err)=>
    {
      this.toastr.error(err);
    })
  }

  forgot() {
    let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    if (!this.cnfPswd) {
      return this.toastr.error("Please fill Confirm Password");
    } else if (!this.newPswd) {
      return this.toastr.error("Please fill New Password");
    } else if (this.cnfPswd != this.newPswd) {
      return this.toastr.error("Password Mismatch");
    }else if(!strongRegex.test(this.newPswd))
    {
      return this.toastr.error("Password Invalid");
    }
    else {
      let Email = localStorage.getItem('email')
      let obj = {
        'mobile_num': JSON.parse(Email),
        'newPswd': this.newPswd,
        'cnfPswd': this.cnfPswd
      }
      // console.log(obj);
      this.usr.forgot(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.toastr.success("Password Updated");
          this.router.navigate(['login']);
        }else if(res.code===402)
        {
          this.toastr.error(res.message);
        }
        else
        {
          this.toastr.error(res.message);
          this.router.navigate(['login']);
        }
      });
    }
  }
}
